import { Entity, Field } from 'typegraph';

@Entity({one: "message", many: "messagesUser"})
export default class MessageUser {

	@Field()
	public id: string;

	@Field()
	public type: string;

	@Field()
	public summary: string;

	@Field()
	public description: string;

	@Field()
	public startDate: string;

	@Field()
	public name: string;

}



// WEBPACK FOOTER //
// ./src/panels/announcements/entities/MessageUser.ts